import { InlineNotification } from '@carbon/react';
import { useLoadableAtomValue } from 'lib/hooks/useLoadableAtomValue';
import { TractNRI } from 'components/nri-table/types';
import { FullNRITable } from 'components/nri-table/nri-table';
import { entityTractNriAtom } from './atoms';
import style from './slot-table.module.scss';

interface SlotAllocationsTableProps {
  entityId: number;
}

export const SlotAllocationsTable = ({
  entityId,
}: SlotAllocationsTableProps) => {
  const nriData = useLoadableAtomValue<TractNRI[], Error>(
    entityTractNriAtom(entityId)
  );

  const isLoading = nriData.state === 'loading';
  const hasError = nriData.state === 'hasError';
  const slots = nriData.state === 'hasData' ? nriData.data : [];

  return (
    <div className={style.slotTable}>
      {hasError && (
        <InlineNotification
          kind="error"
          title={nriData.error.message}
          lowContrast
        />
      )}
      <FullNRITable
        tractNRIRows={slots}
        isLoading={isLoading}
        tableId="entity-tab-slot-allocations-table"
      />
    </div>
  );
};
